import { createStore } from 'redux';
//import DatasetUrls from 'resources/datasetUrls.json'
//import ProductUrls from 'resources/productUrls.json'
import catProUrls from 'resources/urls.json'

const cpUrls = catProUrls 
//const dsUrls = DatasetUrls;
//const pUrls = ProductUrls

const initialState = {
  zone: undefined,
  zones: {},
  features: undefined,
  geoAreas: undefined,
  geoArea: 'full-domain',
  universes: {},
  universe: undefined,
  parameters: undefined,
  parameter:undefined,
  dataset: undefined,
  datasets: undefined,
  product: undefined,
  products: undefined,
  depth: undefined,
  depths: undefined,
  stats: undefined,
  urls: [],
  popup: undefined,
  tooltip: undefined,
  loading: true,
  datasetUrls: {},
  productUrls: {},
  //allData: undefined,
  observations: false,
  about: false
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ZONES':
      return {
        ...state,
        zones: action.payload,
      };
    case 'SET_ZONE':
     return {
        ...state,
        ...updateZone(action.payload.zone, action.payload.features, action.payload.allData, state, 'force' in action.payload ? action.payload.force : {})
      };
    case 'SET_UNIVERSE':
     return {
        ...state,
        ...updateUniverse(state.universes, action.payload, state, [state.zone])
      };
    case 'SET_PARAMETER':
     return {
        ...state,
        ...updateParameter(state.parameters, action.payload, state, [state.zone, state.universe])
      };
    case 'SET_DATASET':
     return {
        ...state,
        ...updateDataset(state.datasets, action.payload, state, [state.zone, state.universe, state.parameter])
      };
    case 'SET_PRODUCT':
     return {
        ...state,
        ...updateProduct(state.products, action.payload, state, [state.zone, state.universe, state.parameter, state.dataset])
      };
    case 'SET_GEO_AREA':
     return {
        ...state,
        ...updateGeoArea(state.geoAreas, action.payload, state)
      };
    case 'SET_DEPTH':
     return {
        ...state,
        ...updateDepth(state.depths, action.payload)
      };
    case 'SET_URLS':
     return {
        ...state,
        urls: action.payload
      };
    case 'SET_POPUP':
     return {
        ...state,
        popup: action.payload
      };
    case 'SET_TOOLTIP':
     return {
        ...state,
        tooltip: action.payload
      };
    case 'SET_LOADING':
     return {
        ...state,
        loading: action.payload
      };
    case 'SET_OBSERVATIONS':
     return {
        ...state,
        observations: action.payload
      };
    case 'SET_ABOUT':
     return {
        ...state,
        about: action.payload
      };
    default:
      return state;
  }
};

function reduceName(arr){
  return arr.reduce((obj, item) => ({...obj, [item['name']]: item }), {}) 
}

function removeNodata(key){
    return function(item){
      //if (item[key] == undefined)
      //  debugger
      if (item[key].length > 0) return item;
    }
}

function removeNodataUniverses(){
    return function(item){
      if ("variables" in item && item["variables"].length > 0) //Universos sin datos pueden mandar parameters vacios
        for(var v in item["variables"]) {
          if("datasets" in item["variables"][v] && item["variables"][v]["datasets"].length > 0)
            return item;
        }
    }
}

function updateState(currState, newStates){
  if (Object.keys(newStates).length == 0)
    return undefined
  return currState in newStates ? currState : newStates[Object.keys(newStates)[0]].name
}


function updateZone(zone, features, allData, state, force = {}) {
  let universes = reduceName(allData["universes"].filter(removeNodataUniverses()))
  //let universe = state.universe in universes ? state.universe : universes[Object.keys(universes)[0]].name
  state.features = features;
  //let datasetUrls = (zone in dsUrls) ? dsUrls[zone] : {}
  //let productUrls = (zone in pUrls) ? pUrls[zone] : {}
  return {
    zone: zone,
    features: features,
    universes: universes,
    //datasetUrls: datasetUrls,
    //productUrls: productUrls,
    allData: allData,
    ...updateUniverse(universes, updateState(state.universe, universes), state, [zone] ,force)
  }
}

function updateUniverse(universes, universe, state, path, force = {}) {
  let parameters = Object.keys(universes).length > 0 ? reduceName(universes[universe].variables.filter(removeNodata("datasets"))) : {}
  //let parameter = state.parameter in parameters ? state.parameter : parameters[Object.keys(parameters)[0]].name
  return {
    universe: "universe" in force ? force["universe"] : universe,
    parameters: parameters,
    ...updateParameter(parameters, updateState(state.parameter, parameters), state, path.concat([universe]) ,force)
  }
}

function updateParameter(parameters, parameter, state, path, force = {}) {
  let datasets = Object.keys(parameters).length > 0 ? reduceName(parameters[parameter].datasets.filter(removeNodata("products"))) : {}
  //let dataset = state.dataset in datasets ? state.dataset : datasets[Object.keys(datasets)[0]].name
  return {
    parameter: "parameter" in force ? force["parameter"] : parameter,
    datasets: datasets,
    ...updateDataset(datasets, updateState(state.dataset, datasets), state, path.concat([parameter]), force)
  }
}

function updateDataset(datasets, dataset, state, path, force = {}) {
  let products = Object.keys(datasets).length > 0 ? reduceName(datasets[dataset].products.filter(removeNodata("subareas"))) : {}
  //let product = state.product in products ? state.product : products[Object.keys(products)[0]].name
  return {
    dataset: "dataset" in force ? force["dataset"] : dataset,
    products: products,
    ...updateProduct(products, updateState(state.product, products), state, path.concat([dataset]), force)
  }
}

function formatId(str) {
  return str.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

function parseGeoAreas(subareas, state) {
  let geoAreas = reduceName(subareas.filter(removeNodata("depths")))
  if ("mediterranean-sea" in geoAreas)
    geoAreas["full-domain"] = geoAreas["mediterranean-sea"]
  if (!("full-domain" in geoAreas)) 
    geoAreas["full-domain"] = {name:"full-domain", fullname:"Full Domain", depths: [{name:"-"}]}
  else
    geoAreas["full-domain"]["fullname"] = "Full Domain"
  state.features.forEach((f) => {if (geoAreas[f.properties.subZone]) geoAreas[f.properties.subZone]['fullname'] = f.properties.NAME})
  Object.keys(geoAreas).forEach((k) => {
    if (!("fullname" in geoAreas[k])) {
      geoAreas[k]["fullname"] = formatId(geoAreas[k]["name"])
      geoAreas[k]["mapData"] = false
    } else {
      geoAreas[k]["mapData"] = true
    }
  })
  return geoAreas
}

function updateProduct(products, product, state, path, force = {}) {
  let geoAreas = Object.keys(products).length > 0 ? parseGeoAreas(products[product].subareas, state) : {}
  let geoArea = state.geoArea in geoAreas ? state.geoArea : "full-domain"
  let datasetUrls = {}
  let productUrls = {}
  try {
    datasetUrls = cpUrls[path[0]][path[1]][path[2]][path[3]][product]["od"]
  } catch {}
  try {
    productUrls = cpUrls[path[0]][path[1]][path[2]][path[3]][product]["pn"]
  } catch {}
  return {
    product: "product" in force ? force["product"] : product,
    geoAreas: geoAreas,
    datasetUrls: datasetUrls,
    productUrls: productUrls,
    ...updateGeoArea(geoAreas, geoArea, state)
  }
}

function updateGeoArea(geoAreas, geoArea, state) {
  let depths = Object.keys(geoAreas).length > 0 ? reduceName(geoAreas[geoArea].depths) : {} //.filter(removeNodata("stats")))
  //let depth = state.depth in depths ? state.depth : depths[Object.keys(depths)[0]].name
  return {
    geoArea: geoArea,
    depths: depths,
    ...updateDepth(depths, updateState(state.depth, depths))
  }
}

function updateDepth(depths, depth) {
  let stats = Object.keys(depths).length > 0 ? depths[depth].stats : {}
  return {
    depth:depth,
    stats: stats
  }
}

const store = createStore(rootReducer);

export default store;
